import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import SurveyFormRoute from "./components/SurveyRoute";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./components/Header";
import Splash from "./components/Splash";
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2, 4, 2, 4),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(),
    },
  },
  appChild: {
    [theme.breakpoints.up("md")]: {
      width: "90vw",
    },
    // [theme.breakpoints.down("sm")]: {
    //   width: "90vw",
    // },
  },
}));

function App() {
  const classes = useStyles();
  return (
    <BrowserRouter>
      <Grid
        container
        direction="column"
        alignItems="center"
        className={classes.root}
      >
        <Grid item key="header" className={classes.appChild}>
          <Header></Header>
        </Grid>
        <Grid item key="body" className={classes.appChild}>
          <Switch>
            <Route path="/respond/:invitationId/">
              <SurveyFormRoute />
            </Route>
            <Route>
              <Splash />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </BrowserRouter>
  );
}

export default App;
